import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiMaarssenEindhovenAirportPage() {
  return (
    <CityAirportTemplate
      city="Maarssen"
      airport="eindhoven"
      airportName="Eindhoven Airport"
      price={87.50}
      distance="75 km"
      duration="58-65 minuten"
    />
  );
}
